import { IncentivesValueObjectsPayoutRuleTypeEnum } from 'generated/resources/graphql'

type PayoutRule = {
  rule: IncentivesValueObjectsPayoutRuleTypeEnum
  rangeFrom: number
  rangeTo?: number | null
}

export type PayoutRuleSummary = {
  threshold: number | null
  cap: number | null
}

export const getPayoutRuleSummary = (rules: PayoutRule[]): PayoutRuleSummary => {
  const cliffRule = rules.find((r) => r.rule === 'cliff')
  const linearRule = rules.find((r) => r.rule === 'linear')

  const threshold = cliffRule ? (cliffRule.rangeTo ?? null) : (linearRule?.rangeFrom ?? null)
  const cap = linearRule?.rangeTo ?? null

  return { threshold, cap }
}
